import React, { useState, useEffect, useRef } from 'react';
import { FaSpotify } from 'react-icons/fa';
import './Spotify.css';

function Spotify() {
    const [data, setData] = useState(null);
    const [now, setNow] = useState(Date.now());
    const textRef = useRef(null);
    const containerRef = useRef(null);
    const [isMarquee, setIsMarquee] = useState(false);
    const DISCORD_ID = "836647735809146930";

    useEffect(() => {
        if (textRef.current && containerRef.current) {
            setIsMarquee(textRef.current.scrollWidth > containerRef.current.clientWidth);
        }
    }, [data]);

    useEffect(() => {
        const fetchStatus = async () => {
            try {
                const res = await fetch(`https://api.lanyard.rest/v1/users/${DISCORD_ID}`);
                const json = await res.json();
                if (json.success) setData(json.data);
            } catch (e) { console.error(e); }
        };
        fetchStatus();
        const interval = setInterval(fetchStatus, 3000);
        const timeInterval = setInterval(() => setNow(Date.now()), 1000);
        return () => { clearInterval(interval); clearInterval(timeInterval); };
    }, []);

    const formatTime = (ms) => {
        const sec = Math.floor((ms / 1000) % 60);
        const min = Math.floor((ms / (1000 * 60)) % 60);
        return `${min}:${sec < 10 ? '0' : ''}${sec}`;
    };

    if (!data || !data.spotify) return null;

    const s = data.spotify;
    const total = s.timestamps.end - s.timestamps.start;
    const current = now - s.timestamps.start;
    const progress = Math.min(100, Math.max(0, (current / total) * 100));

    return (
        <div className="spotify-horizontal">
            <div className="spotify-left-side">
                <img src={s.album_art_url} alt="Cover" className="spotify-horizontal-img" />
            </div>
            <div className="spotify-right-side">
                <div className="spotify-horizontal-header">
                    <FaSpotify size={14} color="#1DB954" /> <span>LISTENING TO SPOTIFY</span>
                </div>

                <div className="spotify-song-info" ref={containerRef}>
                    <div className={`song-name-h3 ${isMarquee ? 'marquee' : ''}`} ref={textRef}>
                        {s.song}
                    </div>
                    <div className="artist-name-p">{s.artist}</div>
                </div>

                {/* КОНТЕЙНЕР ДЛЯ ПРОГРЕСУ ТА ЧАСУ */}
                <div className="spotify-progress-container">
                    <div className="progress-bar-bg">
                        <div className="progress-bar-inner" style={{ width: `${progress}%` }}></div>
                    </div>
                    <div className="spotify-time-labels">
                        <span>{formatTime(current)}</span>
                        <span>{formatTime(total)}</span>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Spotify;